<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">系统默认昵称</p>
      <div class="content-input">
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
          <el-upload
              action="—"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleChange">
            <el-button v-loading="upLoading" type="success" style="margin-left: 16px;">导入Excel</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="content-main">
<!--      <div class="content-button">-->
<!--        <div>-->
<!--          <el-button type="primary" @click="editNameDialog(-1)">新建标签</el-button>-->
<!--        </div>-->
<!--        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--      </div>-->
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="nickname" label="昵称"></el-table-column>
          <el-table-column property="" label="操作">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editNameDialog(scope.$index,scope.row)" type="text">编辑</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getSysNicknamePageList, uploadNicknameExcel } from '@/api/url'
import {getFormData, imgPostFormData} from '@/api/api'
import Dialog from "@/assets/js/dialog";
import NickNameDialog from "./components/NickNameDialog";
import SearchComponents from "@/components/SearchComponents";

export default {
  name: "SysNickName",
  components: { SearchComponents },
  data() {
    return {
      file: '',
      upLoading: false,

      //搜索
      searchTypeList: [
        {label : '昵称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {

    handleChange(file) {
      // console.log(file)
      this.upLoading = true
      let param = new FormData();
      param.append('file', file.raw);
      imgPostFormData(uploadNicknameExcel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getPage(true)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.upLoading = false
      }).catch(()=>{
        this.upLoading = false
      })
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysNicknamePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editNameDialog(idx, row) {
      let _title = '';
      let nameForm = {}
      if (idx > -1) {
        _title = '修改昵称'
        nameForm = Object.assign({}, row);
      }else {
        _title = '新建昵称'
      }
      Dialog.open({
        title: _title,
        component: NickNameDialog,
        data: {
          nameForm: nameForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            row.nickname = result.nickname
        }
      })
    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
